import { CharacterCount } from '@tiptap/extensions'

export type { CharacterCountOptions } from '@tiptap/extensions'
export { CharacterCount } from '@tiptap/extensions'

export default CharacterCount
